module.exports = __webpack_public_path__ + "img/gallery05.30ba730c.jpg";